import Config from "../config/";
export { get, getWithExpiry, remove, set, setWithExpiry } from "./storage";
export const isBrowser = typeof window !== "undefined";

export const getUri = (path: string) => `${Config().shop.url}${path}`;

/**
 * Escapes text to be safe for use in JSON-LD structured data.
 * Removes double quotes that could break JSON parsing.
 */
export const escapeForJsonLd = (text: string | null | undefined): string => {
  if (!text) return "";

  return text.replace(/"/g, "");
};
